import React, { Component } from "react";

export class Inicio extends Component {
  render() {
    return (
      <div>
        <h1>Página de Inicio</h1>
      </div>
    );
  }
}

export default Inicio;



// WEBPACK FOOTER //
// ./src/componentes/Inicio.js